export default __webpack_public_path__ + "static/Hoda-7f1ab389b1b91be44be9023b0c374e67.jpeg";